import type {Recipe} from './types';

export const zabaione: Recipe = {
    id: 10,
    key: "zabaione",
    pictures: [
        {index: 0, url: "https://www.giallozafferano.it/images/181-18153/Zabaione_450x300.jpg"},
    ],
    video: "https://youtu.be/wT0_kRdrgRw?si=pjrU_wYkQLquhTxu",
    i18n: {
        IT: {
            title: "Zabaione al Marsala",
            servings: "Porzioni per 4 persone",
            ingredients: [
                "4 tuorli ",
                "74 g di zucchero",
                "37 g di Marsala",
            ],
            steps: [
                "Mettiamo in una ciotola 4 tuorli.",
                "In una ciotolina mettiamo lo zucchero.",
                "Mettiamo la stessa quantità di Marsala in un bicchiere o una piccola brocca.",
                "Versiamo lo zucchero sui tuorli e montiamo con le fruste elettriche fino ad avere un composto chiaro e spumoso.",
                "Aggiungiamo metà del Marsala e mescoliamo con le fruste elettriche.",
                "Versiamo il Marsala rimasto e continuiamo a montare fino ad avere un composto gonfio e chiaro.",
                "Cuociamo a bagnomaria, mescolando continuamente dal basso verso l’alto con una frusta.",
                "Lo zabaione è pronto quando raggiunge gli 84° C o quando si addensa ma resta fluido.",
                "Spegniamo il fuoco, mescoliamo qualche minuto e poi serviamo.",
            ],
            notes: "Attenzione alla temperatura, nel caso la ciotola sia troppo calda allontanarla dall'acqua. \nRegolare vino e zucchero a seconda della dolcezza desiderata. È possibile usare Vin Santo, vino Moscato, o altri vini dolci.",
        },
        EN: {
            title: "Zabaione with Marsala",
            servings: "Serves 4",
            ingredients: [
                "4 egg yolks",
                "74 g sugar",
                "37 g Marsala wine",
                "Place 4 egg yolks in a bowl.",
            ],
            steps: [
                "In a small bowl, put the sugar.",
                "Pour the same amount of Marsala into a glass or a small jug.",
                "Pour the sugar over the egg yolks and beat with an electric whisk until the mixture is pale and frothy.",
                "Add half of the Marsala and mix with the electric whisk.",
                "Pour in the remaining Marsala and continue to beat until the mixture is light and fluffy.",
                "Cook in a double boiler, stirring continuously from bottom to top with a whisk.",
                "The zabaione is ready when it reaches 84°C or when it thickens but remains fluid.",
                "Turn off the heat, stir for a few minutes, and then serve.",
            ],
            notes: "Pay attention to the temperature; if the bowl becomes too hot, remove it from the water. \nAdjust the wine and sugar according to the desired sweetness. You can use Vin Santo, Moscato wine, or other sweet wines.",
        },
        PL: {
            title: "Zabaione z Marsalą",
            servings: "Porcje dla 4 osób",
            ingredients: [
                "4 żółtka",
                "74 g cukru",
                "37 g Marsali",
            ],
            steps: [
                "Wkładamy 4 żółtka do miski.",
                "W małej miseczce umieszczamy cukier.",
                "Wlewamy taką samą ilość Marsali do szklanki lub małego dzbanka.",
                "Wsypujemy cukier na żółtka i ubijamy mikserem, aż masa będzie jasna i puszysta.",
                "Dodajemy połowę Marsali i mieszamy mikserem.",
                "Wlewamy pozostałą Marsalę i kontynuujemy ubijanie, aż masa będzie napowietrzona i jasna.",
                "Gotujemy na kąpieli wodnej, ciągle mieszając trzepaczką od dołu do góry.",
                "Zabaione jest gotowe, gdy osiągnie 84°C lub gdy zgęstnieje, ale pozostaje płynne.",
            ],
            notes: "Wyłączamy ogień, mieszamy przez kilka minut, a następnie podajemy.\nUważaj na temperaturę, jeśli miska jest zbyt gorąca, usuń ją z wody. Dostosuj ilość wina i cukru w zależności od pożądanej słodyczy. Można użyć Vin Santo, wina Moscato lub innych słodkich win.",
        },
    },
};
